__webpack_require__.p = "https://cdn.10bis.co.il/10bis-spa-static-dev-staging/";